import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const SendBitcoinModal = ({ show, handleClose, handleSend, selectedWalletAddress }) => {
  const [recipientAddress, setRecipientAddress] = useState('');
  const [amount, setAmount] = useState('');
  const [sending, setSending] = useState(false);
  const [transactionId, setTransactionId] = useState('');

  const closeModal = () => {
    setTransactionId('');
    handleClose();
  };

  const handleSendClick = async () => {
    setSending(true);
    try {
      const result = await handleSend({ selectedWalletAddress, recipientAddress, amount });
      const txid = typeof result === 'object' ? result?.transactionId || result?.TransactionId : '';
      if (txid) {
        setTransactionId(txid);
        setRecipientAddress('');
        setAmount('');
      } else if (result) {
        setRecipientAddress('');
        setAmount('');
        handleClose();
      }
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal show={show} onHide={closeModal} className="tyk-modal" centered>
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>{transactionId ? 'BTC Send Confirmed' : 'Send Bitcoin'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {transactionId ? (
          <div className="tyk-panel">
            <span className="tyk-kicker">Broadcast proof</span>
            <p className="mb-3 text-slate-200">
              Your send request was accepted and returned a transaction id. Final wallet state still follows BTC confirmation and reconciliation status.
            </p>
            <div className="tyk-stat">
              <span>Transaction ID</span>
              <strong className="text-base break-all">{transactionId}</strong>
            </div>
          </div>
        ) : (
          <Form>
            <Form.Group controlId="selectedWalletAddress" className="mb-3">
              <Form.Label>Sending wallet</Form.Label>
              <Form.Control
                className="tyk-input"
                type="text"
                value={selectedWalletAddress}
                readOnly
              />
            </Form.Group>
            <Form.Group controlId="recipientAddress" className="mb-3">
              <Form.Label>Recipient address</Form.Label>
              <Form.Control
                className="tyk-input"
                type="text"
                placeholder="Paste a BTC address"
                value={recipientAddress}
                onChange={(e) => setRecipientAddress(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="amount">
              <Form.Label>Amount (BTC)</Form.Label>
              <Form.Control
                className="tyk-input"
                type="number"
                placeholder="0.00000000"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </Form.Group>
          </Form>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal} disabled={sending}>
          {transactionId ? 'Done' : 'Close'}
        </Button>
        {!transactionId && (
          <Button variant="primary" onClick={handleSendClick} disabled={sending}>
            {sending ? 'Sending...' : 'Send BTC'}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export { SendBitcoinModal };

